import { Link, useParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { DetailHeader } from '@/components/common/DetailHeader'
import { useProductsAdmin } from '@/features/product/hooks'
import { StagesPanel } from '@/features/admin/stages/components/StagesPanel'
import { GeneralPanel } from './components/GeneralPanel'
import { ProductSectionsPanel } from './components/ProductSectionsPanel'
import { CashScheduleTemplateEditor } from '@/features/contract/financing/components/CashScheduleTemplateEditor'

export function ProductDetailPage() {
  const { code: productCode } = useParams<{ code: string }>()
  const products = useProductsAdmin()
  const product = products.data?.find(p => p.code === productCode)

  if (products.isLoading) return <div className="p-4">Ładowanie...</div>
  if (!product) {
    return (
      <div className="p-4">
        <p className="text-sm text-red-600">Produkt nie znaleziony.</p>
        <Link to="/settings/products" className="text-sm text-sky-700 underline">← wróć do listy produktów</Link>
      </div>
    )
  }

  return (
    <div className="flex flex-col w-full h-full">
      <DetailHeader
        title={product.labelPl}
        subtitle={
          <span className="font-mono">
            {product.code} · {product.isActive ? 'aktywny' : 'nieaktywny'}
          </span>
        }
      />

      <Tabs defaultValue="general" className="flex-1 flex flex-col gap-0 overflow-hidden">
        <TabsList className="rounded-none w-full justify-start gap-2 px-4 border-b bg-white h-auto">
          <TabsTrigger value="general">Ogólne</TabsTrigger>
          <TabsTrigger value="sections">Sekcje formularza</TabsTrigger>
          <TabsTrigger value="stages">Etapy</TabsTrigger>
          <TabsTrigger value="schedule">Harmonogram</TabsTrigger>
        </TabsList>

        <TabsContent value="general" className="flex-1 overflow-auto p-4">
          <GeneralPanel product={product} />
        </TabsContent>
        <TabsContent value="sections" className="flex-1 overflow-auto p-4">
          <ProductSectionsPanel productCode={product.code} />
        </TabsContent>
        <TabsContent value="stages" className="flex-1 overflow-auto p-4">
          <StagesPanel owner={{ kind: 'product', code: product.code }} gating />
        </TabsContent>
        <TabsContent value="schedule" className="flex-1 overflow-auto p-4">
          <CashScheduleTemplateEditor scope="products" code={product.code} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
